import { AutoLinkPlugin } from '@lexical/react/LexicalAutoLinkPlugin'
import { ClickableLinkPlugin } from '@lexical/react/LexicalClickableLinkPlugin'
import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin'
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin'
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin'
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin'
import classNames from 'classnames'

import { useTranslate } from 'lib/tolgee'
import { LexicalSyncState } from 'modules/dashboard/lexical-sync-state'
import { TextToolbar } from 'modules/dashboard/text-toolbar'

import { editorConfig, MATCHERS } from './text-editor.consts'
import type { ITextEditorView } from './text-editor.types'
import { HTMLToEditorState, validateUrl } from './text-editor.utils'
import translations from './text.editor.i18n'
import './text-editor.styles.scss'

export const TextEditorView = ({ textValue, hasFocus, handleChange, toolbarAlign, isViewMode }: ITextEditorView) => {
  const t = useTranslate()

  return (
    <LexicalComposer
      initialConfig={{
        ...editorConfig,
        editorState: HTMLToEditorState(textValue),
        editable: !isViewMode,
      }}
    >
      <div className={classNames(['editor-container', { hasFocus }])}>
        {hasFocus && <TextToolbar align={toolbarAlign} />}
        <LexicalSyncState textValue={textValue} />
        <LinkPlugin validateUrl={validateUrl} />
        <ClickableLinkPlugin />
        <AutoLinkPlugin matchers={MATCHERS} />
        <RichTextPlugin
          contentEditable={<ContentEditable className="content-editable" spellCheck={false} />}
          placeholder={<div className="placeholder">{t(translations.typeHere)}</div>}
          ErrorBoundary={() => <div className="error-boundary">{t(translations.errorLoading)}</div>}
        />
        <HistoryPlugin />
        <OnChangePlugin onChange={handleChange} />
      </div>
    </LexicalComposer>
  )
}
